import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer";

const Booking: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#9600ff] flex flex-col">
      {/* Header */}
      <header className="container mx-auto px-4 py-6 flex justify-between items-center">
        <div className="flex items-center space-x-2 md:space-x-3">
          {/* Logo Icon */}
          <div className="relative">
            <svg 
              className="w-12 h-12 md:w-16 md:h-16 text-white" 
              viewBox="0 0 32 32" 
              fill="currentColor"
            >
              {/* Main star shape */}
              <path d="M16 2L19.09 11.26L28 12L19.09 12.74L16 22L12.91 12.74L4 12L12.91 11.26L16 2Z" />
              {/* Inner sparkle */}
              <path d="M16 8L17.5 12.5L22 14L17.5 15.5L16 20L14.5 15.5L10 14L14.5 12.5L16 8Z" fill="rgba(255,255,255,0.3)" />
            </svg>
          </div>
          {/* Brand Name */}
          <div className="text-white text-xl md:text-3xl font-bold">Startup Worth</div>
        </div>
        <button
          onClick={() => navigate("/")}
          className="bg-white text-purple-600 px-4 md:px-6 py-2 md:py-3 rounded-full font-semibold hover:bg-opacity-90 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          Back to Home
        </button>
      </header>

      {/* Main Content */}
      <main className="flex-1 container mx-auto px-4 pb-8">
        {/* Page Title */}
        <div className="text-center mb-8">
          <h1 className="text-white text-3xl md:text-5xl font-bold mb-4">
            Book a Consultation
          </h1>
          <p className="text-white/80 text-lg md:text-xl max-w-2xl mx-auto">
            Schedule a personalized financial consultation with our experts to get detailed insights about your startup valuation.
          </p>
        </div>

        {/* Booking Widget */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 md:p-8">
            <div className="mb-6">
              <h2 className="text-white text-2xl font-semibold mb-2">Financial Planning Consultation</h2>
              <p className="text-white/80">
                Get expert guidance on your startup's financial planning and valuation strategy.
              </p>
            </div>
            
            {/* Zoho Bookings Iframe */}
            <div className="bg-white rounded-xl overflow-hidden shadow-lg">
              <iframe 
                width="100%" 
                height="750px" 
                src="https://statupworth.zohobookings.in/portal-embed#/333101000000039052" 
                frameBorder="0" 
                allowFullScreen
                title="Book Financial Planning Consultation"
                className="w-full"
              />
            </div>
          </div>
        </div>

        {/* Additional Information */}
        <div className="max-w-4xl mx-auto mt-8">
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-white font-semibold mb-2">30 Minutes</h3>
              <p className="text-white/80 text-sm">Focused consultation session</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h3 className="text-white font-semibold mb-2">One-on-One</h3>
              <p className="text-white/80 text-sm">Personalized expert guidance</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 text-center">
              <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-white font-semibold mb-2">Expert Advice</h3>
              <p className="text-white/80 text-sm">Professional financial insights</p>
            </div>
          </div>
        </div>
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Booking;
